import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import styled from 'vue-styled-components';
import { i18n } from '@/i18n';
import { appendImportantStyle } from '@/utils/display/styleUtil';
import { CustomStyle } from '@/appLogic/interfaces/style';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleClickBtn',
  props: {
    labelText: {},
    customStyle: { default: undefined }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

// style variables
const Button = styled.button`
  ${{ ...appendImportantStyle(props?.customStyle?.['Button'] ?? {}) }}
`;

//変数
const t = i18n.t;

//関数
const emitClick = () => {
  emits('click');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Button, {
    class: "bg-blue-500 w-auto h-9 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded",
    onClick: emitClick
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)(_ctx.labelText)), 1)
    ], undefined, true),
    _: 1
  }))
}
}

})